
import Cookies from 'js-cookie';

import Base from '../base';

const COOKIE_NAME_DEFAULT = 'ProductDisclaimer';
const COOKIE_EXPIRE_DAYS = 365;
const COOKIE_PATH = '/';

const COOKIE_CONFIG = {
	expires: COOKIE_EXPIRE_DAYS,
	path: COOKIE_PATH,
	secure: true,
	sameSite: 'None',
};

class ProductDisclaimer extends Base {
	start() {
		if (!this.options.disclaimerVersion) {
			console.warn('Missing required disclaimer version');
		}

		this.on('click');
	}

	get cookieName() {
		return this.options.cookieName || COOKIE_NAME_DEFAULT;
	}

	onClick({ target }) {
		if (target === this.refs.accept) {
			this.onAccept();
		} else if (target === this.refs.show) {
			this.onShow();
		}
	}

	onAccept() {
		const { options: { disclaimerVersion } } = this;

		Cookies.set(this.cookieName, disclaimerVersion, COOKIE_CONFIG);

		this.el.classList.add('is-accepted');
	}

	onShow() {
		Cookies.remove(this.cookieName, COOKIE_CONFIG);

		this.el.classList.remove('is-accepted');
	}
}

export default ProductDisclaimer;
